import { ThreadMessage } from '@flowwai-frontend/bps-officer-web/graphql'
import { getErrorMessageFromErrorType } from '@flowwai-frontend/shared/utils/common'
import { MessageModel } from '@flowwai-frontend/shared-web/ai-chat-support/data-access'

import { convertGqlMessageTypeToLocalMessageType } from '../../factories/threadMessageFactories'

import { AskQueryInThreadMutation as Mutation } from './mutation.generatedTypes'

interface ResponseArgsType {
   data: Mutation
   onFailure?: (
      errorMessage: string,
      data: Mutation['askQueryInThread']
   ) => void
   onSuccess?: (message: MessageModel) => void
}

interface ReturnType {
   handleAPIResponse: (args: ResponseArgsType) => void
}

const useAPIResponseHandler = (): ReturnType => {
   const handleAPIResponse = (args: ResponseArgsType): void => {
      if (!args.data) return
      const { askQueryInThread } = args.data

      switch (askQueryInThread.__typename) {
         case 'AskQueryInThreadResult': {
            const newMessageData = convertGqlMessageTypeToLocalMessageType(
               askQueryInThread.message as ThreadMessage
            )
            const newMessage = MessageModel.create(newMessageData)

            args.onSuccess?.(newMessage)
            break
         }
         default: {
            const errorType = askQueryInThread.__typename
            const errorMessage = getErrorMessageFromErrorType(errorType)

            args.onFailure?.(errorMessage, askQueryInThread)
         }
      }
   }
   return { handleAPIResponse }
}

export default useAPIResponseHandler
